import moment from "moment";
import _ from "lodash";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ErrorOccured from "@/components/shared/ErrorOccured.vue";
import PpcStrategies from "@/components/PpcStrategies";
import PpcSbStrategies from "@/components/PpcSbStrategies";
import PpcProducts from "@/components/PpcProducts";
import PpcBooster from "@/components/PpcBooster";
import PpcBidOptimizer from "@/components/PpcBidOptimizer";
import PpcProductPrioritization from "@/components/PpcProductPrioritization";
import PpcSbProductPrioritization from "@/components/PpcSbProductPrioritization";
import PPCSettingsSection from "@/components/ppc/PPCSettingsSection.vue";
import { EVENTS } from "@/utils";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
import FetchFiltersMixin from "@/mixins/FetchFiltersMixin.vue";
import PpcBidSettings from "@/components/PpcBidSettings.vue";
import { amz_sp_api_marketplace_ids_country_domains_flipped } from "@/utils/countries";
import PPCSettingsTabs from "@/components/PPCSettingsTabs.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { asyncWait } from "@/utils";
export default {
  name: "PpcSettings",
  mixins: [FetchFiltersMixin, InitializeFiltersMixin, TasksMixin],
  components: {
    PpcStrategies,
    PpcSbStrategies,
    PpcProducts,
    PpcBooster,
    PpcBidOptimizer,
    PpcProductPrioritization,
    PPCSettingsSection,
    ErrorOccured,
    PpcBidSettings,
    PPCSettingsTabs,
    PpcSbProductPrioritization
  },
  data() {
    return {
      dataLoading: true,
      dataLoadingStrategies: true,
      dataLoadingSbStrategies: true,
      dataLoadingBidSettings: true,
      dataLoadingProductPrioritization: true,
      dataLoadingSBProductPrioritization: true,
      errorOccured: false,
      errorOccuredStrategies: false,
      errorOccuredSbStrategies: false,
      errorOccuredBidSettings: false,
      errorOccuredProductPrioritization: false,
      errorOccuredSBProductPrioritization: false,
      initializationFinished: false,
      initializationFinishedStrategies: false,
      initializationFinishedSbStrategies: false,
      initializationFinishedBidSettings: false,
      initializationFinishedProductPrioritization: false,
      initializationFinishedSBProductPrioritization: false,
      filter_settings: {},
      selected_profile_id: "",
      selected_seller: {},
      selected_marketplace: {},
      sp_campaigns_listing_task_identifier: "",
      sb_campaigns_listing_task_identifier: "",
      sp_product_ads_listing_task_identifier: "",
      perfSPRefresh: [],
      perfSBRefresh: []
    };
  },
  props: {
    activateSettings: {
      type: Boolean,
      default: false
    },
    currentTab: {
      type: Object
    }
  },
  async mounted() {
    try {
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_SELLERS_FILTER, this.refreshSellersFilter);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_MARKETPLACES_FILTER, this.onRefreshMarketPlacesFilter);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_BUDGET_STRATEGY, this.refreshPpcBudgetStrategy);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS, this.refreshPpcSettings);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_BID_SETTINGS, this.refreshPpcBidSettings);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_PRODUCT_PRIORITIZATION, this.refreshPpcProductPrioritization);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_SB_PRODUCT_PRIORITIZATION, this.refreshPpcSBProductPrioritization);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_BID_SIMULATOR, this.refreshPpcBidSimulator);
      window.$bus.on(EVENTS.REFRESH_PPC_SETTINGS_SB_BUDGET_STRATEGY, this.refreshPpcSbBudgetStrategy);
      window.$bus.on(EVENTS.REFRESH_PPC_WEEKS_RANGE, this.createWeeksRange);
      window.$bus.on(EVENTS.REFRESH_PPC_SB_WEEKS_RANGE, this.createSbWeeksRange);
      window.$bus.on(EVENTS.DELETE_PPC_STRATEGY, this.handleDeleteStrategy);
      window.$bus.on(EVENTS.DELETE_PPC_SB_STRATEGY, this.handleDeleteSbStrategy);
      await this.initializeSellersFilter(this.ppcSellersFilterSet);
      this.sellers_filter.selectWhenNoSelected(this.sellers_filter.filterItems[0], "id");
      this.sellers_filter.selectOneWhenMultipleSelected(this.sellers_filter.filterItems[0], "id");
      this.sellers_filter.apply();
      await this.onRefreshMarketPlacesFilter(true);
      window.$bus.trigger(EVENTS.REFRESH_PPC_AUTOMATION_STATUS);
      await this.createWeeksRange();
      await this.createSbWeeksRange();
      await this.refreshPpcSettings();
      this.initializationFinished = true;
      window.$bus.trigger(EVENTS.PPC_SETTINGS_INITIALIZED, true);
    } catch (error) {
      window.$bus.trigger("showDanger", {
        message: `Error loading PPC Settings`,
        delay: 50,
        visible: true
      });
      this.dataLoading = false;
      this.errorOccured = true;
    }
  },
  async beforeUnmount() {
    await this.$store.dispatch("ppcSettingsClearStore");
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_SELLERS_FILTER, this.refreshSellersFilter);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_MARKETPLACES_FILTER, this.onRefreshMarketPlacesFilter);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_BUDGET_STRATEGY, this.refreshPpcBudgetStrategy);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS, this.refreshPpcSettings);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_BID_SETTINGS, this.refreshPpcBidSettings);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_PRODUCT_PRIORITIZATION, this.refreshPpcProductPrioritization);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_SB_PRODUCT_PRIORITIZATION, this.refreshPpcSBProductPrioritization);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_BID_SIMULATOR, this.refreshPpcBidSimulator);
    window.$bus.off(EVENTS.REFRESH_PPC_SETTINGS_SB_BUDGET_STRATEGY, this.refreshPpcSbBudgetStrategy);
    window.$bus.off(EVENTS.REFRESH_PPC_WEEKS_RANGE, this.createWeeksRange);
    window.$bus.off(EVENTS.REFRESH_PPC_SB_WEEKS_RANGE, this.createSbWeeksRange);
    window.$bus.off(EVENTS.DELETE_PPC_STRATEGY, this.handleDeleteStrategy);
    window.$bus.off(EVENTS.DELETE_PPC_SB_STRATEGY, this.handleDeleteSbStrategy);
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      strategies: state => state.ppc_settings.strategies,
      weekFilled: state => state.ppc_settings.weekFilled,
      sellers_filter: state => state.ppc_v2.sellers_filter,
      marketplaces_filter: state => state.ppc_v2.marketplaces_filter,
      currencies_filter: state => state.ppc_settings.currencies_filter,
      currentWeek: state => state.ppc_settings.currentWeek,
      connected_profiles_for_seller: state => state.ppc_settings.connected_profiles_for_seller,
      weeksRange: state => state.ppc_settings.weeksRange,
      sbWeeksRange: state => state.ppc_sb_settings.weeksRange,
      // products: state => state.ppc.settings.products,
      // boost: state => state.ppc.settings.boost,
      bid_settings: state => state.ppc_settings.bid_settings,
      isOmnyUser: state => state.auth.isOmnyUser,
      account_profiles: state => state.account.profiles,
      sp_portfolio: state => state.ppc_settings.sp_portfolio,
      sb_portfolio: state => state.ppc_settings.sb_portfolio,
      sp_product_ads_by_campaign_id: state => state.ppc_settings.sp_product_ads_by_campaign_id,
      ppcPageCurrentTabValue: state => state.ppc_v2.currentTabValue
    }),
    ppcSettings() {
      return this.$store.state.ppcSettings;
    },
    ...mapGetters(["workspaceCurrent", "accountProfileIdGet", "accountAdvertisingBySellerIdGet", "ppcSettingsWeeksGet", "ppcSbSettingsWeeksGet", "accountProfileCurrencyGet", "ppcV2GetFilters", "ppcCampaignIdsGet", "ppcSBCampaignIdsGet", "ppcCampaignGroupIdsGet", "ppcCampaignIdsFromSPProductPrioritizationGet"]),
    currency() {
      return this.accountProfileCurrencyGet(this.ppcSettingsFilters);
    },
    ppcSettingsFilters() {
      let sellers_filter_item = this.sellers_filter.selectedItems.slice(-1).pop();
      this.selected_seller = sellers_filter_item;
      let marketplaces_filter_item = this.marketplaces_filter.selectedItems.slice(-1).pop();
      this.selected_marketplace = marketplaces_filter_item;
      return {
        seller_id: sellers_filter_item?.account_id,
        sales_channel: marketplaces_filter_item?.sales_channel,
        country_code: marketplaces_filter_item?.country_code,
        marketplace_id: marketplaces_filter_item?.marketplace_id
      };
    }
  },
  methods: {
    ...mapActions(["ppcBudgetDelete", "ppcBudgetStrategy", "ppcBudgetStrategyFromBQ", "ppcSbBudgetDelete", "ppcSbBudgetStrategy", "ppcSbBudgetStrategyFromBQ", "ppcBudget", "ppcProducts", "workspaceList", "ppcBoost", "ppcBidAdjustement", "authStatus", "ppcBidSettingGet", "ppcProductPrioritizationGetFromBQ", "ppcSBProductPrioritizationGetFromBQ", "ppcBidSimulatorGetFromBQ", "ppcProductPrioritizationCampaigns", "ppcSBPortfolios", "ppcSPPortfolios", "ppcSBProductPrioritizationCampaigns", "ppcProductPrioritizationCampaignGroups", "ppcSBProductPrioritizationCampaignGroups", "ppcProductPrioritizationGetFromBQByCampaignId", "ppcSBProductPrioritizationGetFromBQByCampaignId", "ppcProductAds"]),
    ...mapMutations(["ppcSellersFilterSet", "ppcMarketplacesFilterSet", "ppcSettingsWeeksRangeSet", "ppcSbSettingsWeeksRangeSet", "ppcConnectedAdvertisingProfilesSet", "ppcCampaignsSet", "ppcCampaignGroupStateSet", "ppcSBCampaignsSet", "ppcSBCampaignGroupStateSet", "ppcProductAdsSet"]),
    async handleDeleteSbStrategy(week) {
      let filter_settings = this.ppcSettingsFilters;
      let weeks_to_delete = this.sbWeeksRange.filter(weekData => weekData.strategy_id == week.strategy_id && weekData.moment.clone().isAfter(moment.max([moment().startOf("isoWeek"), moment(week.start_date).startOf("isoWeek").subtract(1, "week")])));
      const profile_id = this.accountProfileIdGet(filter_settings);
      let payload = {
        seller_list: [filter_settings.seller_id],
        profile_list: [profile_id],
        week_id_list: weeks_to_delete.map(weekData => weekData.week_id),
        weeks: weeks_to_delete.map(weekData => weekData.week)
      };
      await this.ppcSbBudgetDelete(payload);
      await this.createSbWeeksRange();
      await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS_SB_BUDGET_STRATEGY);
    },
    async handleDeleteStrategy(week) {
      let filter_settings = this.ppcSettingsFilters;
      let weeks_to_delete = this.weeksRange.filter(weekData => weekData.strategy_id == week.strategy_id && weekData.moment.clone().isAfter(moment.max([moment().startOf("isoWeek"), moment(week.start_date).startOf("isoWeek").subtract(1, "week")])));
      const profile_id = this.accountProfileIdGet(filter_settings);
      let payload = {
        seller_list: [filter_settings.seller_id],
        profile_list: [profile_id],
        week_id_list: weeks_to_delete.map(weekData => weekData.week_id),
        weeks: weeks_to_delete.map(weekData => weekData.week)
      };
      await this.ppcBudgetDelete(payload);
      await this.createWeeksRange();
      await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS_BUDGET_STRATEGY);
    },
    async refreshPpcSettings() {
      try {
        const perf = [];
        perf.push(performance.now());
        window.$bus.trigger(EVENTS.PPC_SETTINGS_INITIALIZED, false);
        this.dataLoading = true;
        this.filter_settings = this.ppcSettingsFilters;
        this.selected_profile_id = this.accountProfileIdGet(this.filter_settings);
        this.throwIfError(this.selected_profile_id);
        await this.$store.dispatch("ppcSettingsClearStore");
        this.refreshPpcBudgetStrategy();
        this.refreshPpcSbBudgetStrategy();
        await this.refreshPpcBidSettings();
        await this.refreshPpcProductPrioritization();
        await this.refreshPpcSBProductPrioritization();
        perf.push(performance.now());
        //console.log(
        //   `[Perf][PPC Settings Rendering]: ${(perf[1] - perf[0]) / 1000} s`
        // );

        window.$bus.trigger(EVENTS.PPC_STRATEGY_AUTO_SCROLL);
        window.$bus.trigger(EVENTS.PPC_SB_STRATEGY_AUTO_SCROLL);
        this.dataLoading = false;
        this.errorOccured = false;
        window.$bus.trigger(EVENTS.PPC_SETTINGS_INITIALIZED, true);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `No profile Id found for ${this.filter_settings?.seller_id} in ${this.filter_settings?.sales_channel}`,
          delay: 50,
          visible: true
        });
        this.dataLoading = false;
        this.errorOccured = true;
      }
    },
    async refreshPpcSbBudgetStrategy() {
      try {
        this.initializationFinishedSbStrategies = false;
        this.dataLoadingSbStrategies = true;
        let weeks = this.ppcSbSettingsWeeksGet();
        let payload = {
          seller_list: [this.filter_settings.seller_id],
          profile_list: [this.selected_profile_id],
          weeks: weeks
        };
        let payload2 = {
          seller_id: this.filter_settings.seller_id,
          profile_id: this.selected_profile_id,
          weeks: weeks
        };
        await this.ppcSbBudgetStrategy(payload);
        let result = await this.ppcSbBudgetStrategyFromBQ(payload2);
        this.throwIfError(result.data);
        this.dataLoadingSbStrategies = false;
        this.errorOccuredSbStrategies = false;
        this.initializationFinishedSbStrategies = true;
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC SB Budget Strategy`,
          delay: 50,
          visible: true
        });
        this.dataLoadingSbStrategies = false;
        this.errorOccuredSbStrategies = true;
      }
    },
    async refreshPpcBudgetStrategy() {
      try {
        this.initializationFinishedStrategies = false;
        this.dataLoadingStrategies = true;
        let weeks = this.ppcSettingsWeeksGet();
        let payload = {
          seller_list: [this.filter_settings.seller_id],
          profile_list: [this.selected_profile_id],
          weeks: weeks
        };
        let payload2 = {
          seller_id: this.filter_settings.seller_id,
          profile_id: this.selected_profile_id,
          weeks: weeks
        };
        await this.ppcBudgetStrategy(payload);
        let result = await this.ppcBudgetStrategyFromBQ(payload2);
        this.throwIfError(result.data);
        this.dataLoadingStrategies = false;
        this.errorOccuredStrategies = false;
        this.initializationFinishedStrategies = true;
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC Budget Strategy`,
          delay: 50,
          visible: true
        });
        this.dataLoadingStrategies = false;
        this.errorOccuredStrategies = true;
      }
    },
    handleErrorOccured() {
      this.throwIfError(false);
      this.dataLoading = false;
      this.errorOccured = true;
    },
    async refreshPpcBidSettings() {
      try {
        this.initializationFinishedBidSettings = false;
        this.dataLoadingBidSettings = true;
        let payload = {
          seller_list: [this.filter_settings.seller_id],
          profile_list: [this.selected_profile_id],
          marketplace_id: amz_sp_api_marketplace_ids_country_domains_flipped[this.filter_settings.sales_channel.toLowerCase()]
        };
        let result = await this.ppcBidSettingGet(payload);
        await this.refreshPpcBidSimulator();
        this.throwIfError(result.data);
        this.dataLoadingBidSettings = false;
        this.errorOccuredBidSettings = false;
        this.initializationFinishedBidSettings = true;
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC Bid Settings`,
          delay: 50,
          visible: true
        });
        this.dataLoadingBidSettings = false;
        this.errorOccuredBidSettings = true;
      }
    },
    async refreshPpcProductPrioritization(data) {
      try {
        this.perfSPRefresh = [];
        this.perfSPRefresh.push(performance.now());
        this.sp_product_ads_by_campaign_id.clear();
        this.dataLoadingProductPrioritization = true;
        this.initializationFinishedProductPrioritization = false;
        let payload = {
          seller_id: this.filter_settings.seller_id,
          country_code: this.filter_settings.country_code,
          profile_id: this.selected_profile_id,
          page_limit: data?.page_limit || 20,
          page_offset: data?.page_offset || 1,
          portfolio_names: "OmnyAI"
        };
        let result_portfolio = await this.ppcSPPortfolios(payload);
        let result = await this.ppcProductPrioritizationGetFromBQ({
          ...payload,
          portfolio_id: result_portfolio?.portfolioId?.toString()
        });
        this.throwIfError(result.data);
        let result_campaigns = await this.ppcProductPrioritizationCampaigns({
          ...payload,
          portfolio_id: result_portfolio?.portfolioId?.toString(),
          task_type: "list_sp_campaigns_amazon"
        });
        this.dataLoadingProductPrioritization = false;
        this.errorOccuredProductPrioritization = false;
        if (!Array.isArray(result_campaigns.data)) {
          if (result_campaigns.data?.task_id === `${payload.profile_id}_${payload.country_code}_list_sp_campaigns_amazon`) {
            this.sp_campaigns_listing_task_identifier = `${payload.profile_id}_${payload.country_code}_list_sp_campaigns_amazon`;
            this.executeTaskStatusHandler(result_campaigns.data);
            this.checkMultipleTaskStatusPeriodically(this.sp_campaigns_listing_task_identifier);
          }
          return;
        }
        this.finaliseRefreshSPProductPrioritization(payload);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC Product Prioritization`,
          delay: 50,
          visible: true
        });
        this.dataLoadingProductPrioritization = false;
        this.errorOccuredProductPrioritization = true;
      }
    },
    async finaliseRefreshSPProductPrioritization(payload) {
      try {
        let campaign_id_list = this.ppcCampaignIdsGet().sort();
        if (campaign_id_list.length) {
          let payload_campaigns_by_id = {
            ...payload,
            campaign_id_list: campaign_id_list
          };
          let result_campaigns_by_id = await this.ppcProductPrioritizationGetFromBQByCampaignId(payload_campaigns_by_id);
        }
        let campaign_group_id_list = this.ppcCampaignGroupIdsGet();
        if (campaign_group_id_list.length) {
          let payload_campaign_groups = {
            ...payload,
            campaign_group_id_list: campaign_group_id_list
          };
          let result_campaign_groups = await this.ppcProductPrioritizationCampaignGroups(payload_campaign_groups);
        }
        this.initializationFinishedProductPrioritization = true;
        this.perfSPRefresh.push(performance.now());
        console.log(`[Perf][PPC Settings SP Product Prioritization Rendering]: ${(this.perfSPRefresh[1] - this.perfSPRefresh[0]) / 1000} s`);
        let campaign_id_list_for_product_ads = this.ppcCampaignIdsFromSPProductPrioritizationGet().sort();
        if (campaign_id_list_for_product_ads.length) {
          let payload_product_ads = {
            ...payload,
            campaign_id_list: campaign_id_list_for_product_ads,
            task_type: "list_sp_product_ads_amazon"
          };
          let result_product_ads = await this.ppcProductAds(payload_product_ads);
          if (!Array.isArray(result_product_ads.data)) {
            if (result_product_ads.data?.task_id === `${payload.profile_id}_${payload.country_code}_list_sp_product_ads_amazon`) {
              this.sp_product_ads_listing_task_identifier = `${payload.profile_id}_${payload.country_code}_list_sp_product_ads_amazon`;
              this.executeTaskStatusHandler(result_product_ads.data);
              this.checkMultipleTaskStatusPeriodically(this.sp_product_ads_listing_task_identifier);
            }
            return;
          }
        }
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC Product Prioritization`,
          delay: 50,
          visible: true
        });
        this.dataLoadingProductPrioritization = false;
        this.errorOccuredProductPrioritization = true;
      }
    },
    async refreshPpcSBProductPrioritization(data) {
      try {
        this.perfSBRefresh = [];
        this.perfSBRefresh.push(performance.now());
        this.dataLoadingSBProductPrioritization = true;
        this.initializationFinishedSBProductPrioritization = false;
        let payload = {
          seller_id: this.filter_settings.seller_id,
          country_code: this.filter_settings.country_code,
          profile_id: this.selected_profile_id,
          page_limit: data?.page_limit || 20,
          page_offset: data?.page_offset || 1
        };
        let result = await this.ppcSBProductPrioritizationGetFromBQ(payload);
        this.throwIfError(result.data);
        let portfolio_payload = {
          ...payload,
          portfolio_names: "OmnyAI SB"
        };
        let result_portfolio = await this.ppcSBPortfolios(portfolio_payload);
        let result_campaigns = await this.ppcSBProductPrioritizationCampaigns({
          ...payload,
          // portfolio_id: result_portfolio?.portfolioId?.toString(),
          task_type: "list_sb_campaigns_amazon"
        });
        this.dataLoadingSBProductPrioritization = false;
        this.errorOccuredSBProductPrioritization = false;
        if (!Array.isArray(result_campaigns.data)) {
          if (result_campaigns.data?.task_id === `${payload.profile_id}_${payload.country_code}_list_sb_campaigns_amazon`) {
            this.sb_campaigns_listing_task_identifier = `${payload.profile_id}_${payload.country_code}_list_sb_campaigns_amazon`;
            this.executeTaskStatusHandler(result_campaigns.data);
            this.checkMultipleTaskStatusPeriodically(this.sb_campaigns_listing_task_identifier);
          }
          return;
        }
        this.finaliseRefreshSBProductPrioritization(payload);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC SB Product Prioritization`,
          delay: 50,
          visible: true
        });
        this.dataLoadingSBProductPrioritization = false;
        this.errorOccuredSBProductPrioritization = true;
      }
    },
    async finaliseRefreshSBProductPrioritization(payload) {
      try {
        let campaign_id_list = this.ppcSBCampaignIdsGet().sort();
        if (campaign_id_list.length) {
          let payload_campaigns_by_id = {
            ...payload,
            campaign_id_list: campaign_id_list
          };
          let result_campaigns_by_id = await this.ppcSBProductPrioritizationGetFromBQByCampaignId(payload_campaigns_by_id);
          let payload_campaign_groups = {
            ...payload,
            campaign_group_id_list: campaign_id_list
          };
          let result_campaign_groups = await this.ppcSBProductPrioritizationCampaignGroups(payload_campaign_groups);
        }
        this.initializationFinishedSBProductPrioritization = true;
        this.perfSBRefresh.push(performance.now());
        console.log(`[Perf][PPC Settings SB Product Prioritization Rendering]: ${(this.perfSBRefresh[1] - this.perfSBRefresh[0]) / 1000} s`);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error loading PPC SB Product Prioritization`,
          delay: 50,
          visible: true
        });
        this.dataLoadingSBProductPrioritization = false;
        this.errorOccuredSBProductPrioritization = true;
      }
    },
    async refreshPpcBidSimulator() {
      let payload = {
        seller_id: this.filter_settings.seller_id,
        profile_id: this.selected_profile_id
      };
      await this.ppcBidSimulatorGetFromBQ(payload);
    },
    async getFilterValuesForMarketPlacesFilter() {
      await this.initializeConnectedAdvertisingProfilesForSeller();
      let result = await this.getCountriesBasedOnSellers({
        sellers: this.sellers_filter.filterValues
      }, "/ppc/filters/countries");
      let filtered_result = result.filter(item => this.connected_profiles_for_seller.some(profile => item.country_code == profile.countryCode));
      let result_account_profiles_union = filtered_result.map(this.mergeAccountProfileForMarketPlaces);
      return result_account_profiles_union.sort((profile1, profile2) => profile2.spend_eur_30d - profile1.spend_eur_30d);
    },
    async getFilterValuesForSellersFilter() {
      let sellers = await this.getOmnyAccountSellers();
      let result_sellers_profiles_union = sellers.map(this.mergeAccountProfileForSellers);
      return result_sellers_profiles_union.sort((profile1, profile2) => profile2.spend_eur_30d - profile1.spend_eur_30d);
    },
    mergeAccountProfileForMarketPlaces(item) {
      return _.merge(_.find(this.account_profiles, {
        marketplace_id: item?.marketplace_id
      }), item);
    },
    mergeAccountProfileForSellers(item) {
      return _.merge(_.find(this.account_profiles, {
        seller_id: item?.seller_id
      }), item);
    },
    async onRefreshMarketPlacesFilter(check_local_storage) {
      await this.getOmnyAccountProfileIds(this.sellers_filter.filterItems);
      //await this.refreshMarketPlacesFilter();
      await this.initializeMarketplacesFilter(this.ppcMarketplacesFilterSet, check_local_storage);
      this.marketplaces_filter._key = "marketplace_id";
      this.marketplaces_filter.selectWhenNoSelected(this.marketplaces_filter.filterItems[0], "marketplace_id");
      this.marketplaces_filter.selectOneWhenMultipleSelected(this.marketplaces_filter.filterItems[0], "marketplace_id");
      this.marketplaces_filter.apply();
    },
    async initializeConnectedAdvertisingProfilesForSeller() {
      try {
        let selected_seller_id = this.ppcSettingsFilters.seller_id;
        let connected_profiles_for_seller = this.accountAdvertisingBySellerIdGet(selected_seller_id);
        this.throwIfError(connected_profiles_for_seller);
        await this.ppcConnectedAdvertisingProfilesSet(connected_profiles_for_seller);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "No Connected Amazon Advertising Account profile found",
          delay: 50,
          visible: true
        });
        this.dataLoading = false;
        this.errorOccured = true;
      }
    },
    async createSbWeeksRange(params = {
      startWeekNumber: 12,
      endWeekNumber: 36
    }) {
      this.ppcSbSettingsWeeksRangeSet(this.buildWeeksRange(params));
    },
    buildWeeksRange(params = {
      startWeekNumber: 12,
      endWeekNumber: 36
    }) {
      const startWeek = this.currentWeek.clone().subtract(params?.startWeekNumber, "weeks");
      const endWeek = this.currentWeek.clone().add(params?.endWeekNumber, "weeks");
      let nextWeek = startWeek.clone();
      const range = [];
      while (nextWeek.isSameOrBefore(endWeek)) {
        let week_status = "before";
        if (nextWeek.isSame(this.currentWeek)) {
          week_status = "today";
        } else {
          if (nextWeek.isAfter(this.currentWeek)) {
            week_status = "after";
          }
        }
        range.push({
          moment: nextWeek,
          title: nextWeek.format("DD") + " " + nextWeek.format("MMM"),
          week: nextWeek.format("YYYY-MM-DD"),
          week_status: week_status,
          budget_obj: {}
        });
        nextWeek = nextWeek.clone().add(1, "week");
      }
      return range;
    },
    async createWeeksRange(params = {
      startWeekNumber: 12,
      endWeekNumber: 36
    }) {
      this.ppcSettingsWeeksRangeSet(this.buildWeeksRange(params));
    },
    setPPCSPCampaigns(data) {
      this.ppcCampaignsSet(data);
      this.ppcCampaignGroupStateSet(data);
    },
    setPPCSBCampaigns(data) {
      this.ppcSBCampaignsSet(data);
      this.ppcSBCampaignGroupStateSet(data);
    },
    setPPCSPProductAds(data) {
      this.ppcProductAdsSet(data);
    },
    finaliseRefreshSPProductAds() {},
    handleIdle() {},
    handleRunning(data) {
      this.checkMultipleTaskStatusPeriodically(data?.task_id);
    },
    handleFailed(data) {
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "List Campaigns Task failed \n" + data?.task_result ?? "",
        delay: 60 // Show alert less than 60 secs
      });
      const task_type = data?.task_id?.split("_").slice(2).join("_");
      const dataLoadingMap = {
        list_sp_campaigns_amazon: "dataLoadingProductPrioritization",
        list_sb_campaigns_amazon: "dataLoadingSBProductPrioritization"
        // list_sp_product_ads_amazon: "dataLoadingProductPrioritization",
      };
      const errorOccuredMap = {
        list_sp_campaigns_amazon: "errorOccuredProductPrioritization",
        list_sb_campaigns_amazon: "errorOccuredSBProductPrioritization"
        // list_sp_product_ads_amazon: "errorOccuredProductPrioritization",
      };
      this[dataLoadingMap[task_type]] = false;
      this[errorOccuredMap[task_type]] = true;
      if (this.asyncMultipleUpdateInterval[data?.task_id]) {
        clearTimeout(this.asyncMultipleUpdateInterval[data?.task_id]);
        this.asyncMultipleUpdateInterval[data?.task_id] = null;
      }
    },
    async handleFinished(data) {
      const task_type = data?.task_id?.split("_").slice(2).join("_");
      if (this.asyncMultipleUpdateInterval[data?.task_id]) {
        clearTimeout(this.asyncMultipleUpdateInterval[data?.task_id]);
        this.asyncMultipleUpdateInterval[data?.task_id] = null;
      }
      const payload = {
        seller_id: this.filter_settings.seller_id,
        country_code: this.filter_settings.country_code,
        profile_id: this.selected_profile_id,
        page_limit: data?.page_limit || 20,
        page_offset: data?.page_offset || 1
      };
      const setCampaignsMap = {
        list_sp_campaigns_amazon: this.setPPCSPCampaigns,
        list_sb_campaigns_amazon: this.setPPCSBCampaigns,
        list_sp_product_ads_amazon: this.setPPCSPProductAds
      };
      const finalizeRefreshMap = {
        list_sp_campaigns_amazon: this.finaliseRefreshSPProductPrioritization,
        list_sb_campaigns_amazon: this.finaliseRefreshSBProductPrioritization,
        list_sp_product_ads_amazon: this.finaliseRefreshSPProductAds
      };
      setCampaignsMap[task_type](data?.task_result?.flat() ?? []);
      finalizeRefreshMap[task_type](payload);
    }
  }
};